module.exports = __webpack_public_path__ + "static/img/katakura_04.31631bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/katakura_04.jpg
// module id = Z/5u
// module chunks = 0